import React from 'react';
import ToCarView from '../../../../../common/icons/CarIcon';

export default function(props) {
  return {
    width: '16px',
    title: '',
    dataIndex: '',
    className: 'goToCarview',
    render: (text, record) => <ToCarView style={{ cursor: 'pointer', fontSize: '2.5rem' }} onClick={() => props.history.push(`/carview/${record.car.id}`)} />
  };
}
